export default "__VITE_ASSET__b7ca5158__"